import { Component, inject, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { HeaderLayout } from "./header/header.layout";
import { injectNavigationEnd } from "ngxtension/navigation-end";

@Component({
  selector: "app-layout",
  imports: [CommonModule, RouterOutlet],
  templateUrl: "./layout.component.html",
  styleUrl: "./layout.component.scss",
})
export class LayoutComponent {}
